import React, { useState, createElement, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FlexContainer, PerfectCenter, PureSpinner, validateEmail } from 'heliocor-ui'
import { useTranslation } from 'react-i18next';

import { REQUEST_SEND_ACTIVATION_EMAIL, SET_ONBOARDING_TYPE, REQUEST_RESET_CUSTOMER_DATA } from '../store/cafe/actionTypes'
import { phaseTypes } from '../config/phaseTypes.enum'
import { AuthenticationCode } from '../components/authentication/AuthenticationCode';
import { AuthenticationStatus } from '../components/authentication/AuthenticationStatus';
import { AuthenticationRequest } from '../components/authentication/AuthenticationRequest'
import { MissingOrganization } from '../components/authentication/MissingOrganization'

const Authentication = () => {
    
    const url = new URL(window.location.href)
    const urlType = url.searchParams.get("type")

    const { t } = useTranslation()
    const [email, setEmail] = useState('')
    const [type, setType] = useState(urlType || 'PERSON')
    const [index, setIndex] = useState(0)

    const authenticated = useSelector(state => state.config.authenticated)
    const cafeStatus = useSelector(state => state.general.cafeStatus)
    const isRequest = useSelector(state => state.config.isRequest)
    const phase = useSelector(state => state.config.phase)
    const supportEmail = useSelector(state => state.settings.supportEmail)

    const dispatch = useDispatch()
    const resetCustomerData = () => dispatch({ type: REQUEST_RESET_CUSTOMER_DATA })
    const sendActivationEmail = (email, type) => dispatch({ type: REQUEST_SEND_ACTIVATION_EMAIL, email, partyType: type })
    const setPartyType = (type) => dispatch({ type: SET_ONBOARDING_TYPE, partyType: type })

    useEffect(() => {
        const reqStatusesWithIssues = ['NOT_FOUND_REQUEST', 'LENGTH_ORGANIZATION_ID', 'LENGTH_REQUEST_ID', 'REQUEST_NOT_VALID', 'ACCEPTED_REQUEST']
        if (['PERSON_EXISTS'].includes(cafeStatus) && !authenticated) setIndex(2)
        else if (reqStatusesWithIssues.includes(cafeStatus) && !authenticated) setIndex(1)
    }, [cafeStatus, authenticated])

    const sendEmail = () => {
        const _type = urlType || type

        if (!type || ((!validateEmail(email)) && !isRequest) || cafeStatus === 'REQUEST_NOT_VALID') return
        sendActivationEmail(email, _type)
        setPartyType(_type)
        if (!isRequest) setIndex(1)
    }

    const backToEmail = () => {
        resetCustomerData()
        setEmail('')
        setIndex(0)
    }

    const steps = {
        [phaseTypes.PREAPPROVAL]: [
            {
                id: 'whatisYourEmail',
                component: AuthenticationRequest,
                props: {
                    urlType,
                    manageEmail: { email, setEmail },
                    manageType: { typeInURL: !!urlType ,type, setType },
                    sendEmail
                }
            }, {
                id: 'verificationCode',
                component: AuthenticationCode,
                props: {
                    email,
                    sendEmail,
                    backToEmail
                }
            }, {
                id: 'alreadyOnBoarded',
                component: AuthenticationStatus,
                props: {
                    positiveVerification: authenticated,
                    infoMessage: 'warning.authFailed',
                    buttonHelper: {
                        textInfo: 'warning.clickHereToResetApp',
                        buttonValue: 'resetApp',
                        action: backToEmail
                    }
                }
            }
        ],
        [phaseTypes.REQUEST]: [
            {
                id: 'verificationCode',
                component: AuthenticationCode,
                props: {
                    email,
                    sendEmail,
                    backToEmail
                }
            }, {
                id: 'contactSupport',
                component: AuthenticationStatus,
                props: {
                    positiveVerification: authenticated,
                    infoMessage: 'warning.errorWithUrl',
                    ...(supportEmail
                        ? { buttonHelper: { buttonValue: 'contact Support', action: () => window.location.href = `mailto:${supportEmail}` } }
                        : {})
                }
            }
        ],
    }


    if(!cafeStatus && index !== 0) {
        return (
            <PerfectCenter>
                <PureSpinner color='main' />
            </PerfectCenter>
        )
    }

    if(phase === phaseTypes.UNKNOWN_ORG) {
        return <MissingOrganization t={t} />
    }

    return (
        <FlexContainer justifyContent='center' alignItems='center'>
            {createElement(steps[phase][index].component, steps[phase][index].props)}
        </FlexContainer>
    )
}

export { Authentication }